import { ReactNode, lazy } from "react";
import { Navigate } from "react-router-dom";

import { SplashScreen } from "src/components/loading-screen";
import { useWhiteLabel } from "src/context/WhiteLabelContext";

const SportProviderPage = lazy(() => import("src/pages/sportprovider"));
const AssociationWelcomePage = lazy(
  () => import("src/pages/association-portal"),
);
const FederationRegistrationPage = lazy(
  () => import("src/pages/association-portal/register"),
);

type Props = {
  tab: string;
  fallback?: ReactNode;
  welcome?: boolean;
  registration?: boolean;
};

export default function AssociationPortalRoute({
  tab,
  fallback,
  welcome,
  registration,
}: Props) {
  const { isCustomHost, portal, portalLoading } = useWhiteLabel();

  if (portalLoading) return <SplashScreen />;
  if (portal && registration) return <FederationRegistrationPage />;
  if (portal && welcome) return <AssociationWelcomePage />;
  if (isCustomHost && portal) {
    return <SportProviderPage tab={tab} />;
  }
  if (fallback) return <>{fallback}</>;
  return <Navigate to="/404" replace />;
}
